import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/brand/importer/brandImporterActions'

export default importerReducers(actions)
